// @flow
import { DataFetcherContainer } from '@presentational/DataFetcherContainer';
import { shouldSkipDataFetching } from '@src/common-utils/utils';
import React, { useCallback, useContext, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useGetStreamingProjectsMetadataQuery } from '@streaming-projects/service-definitions/streamingProjectsApi';
import { SPOrgContext } from '@streaming-projects/orgs/contexts/SPOrgContext';

import { SPUserCommitDetailsContext } from './SPUserCommitDetailsContext';
import { SPUserCommitMetadataContext } from './SPUserCommitMetadataContext';

export const SPUserCommitMetadataContextProvider = ({ children }) => {
  const params = useParams();
  const commitData = useContext(SPUserCommitDetailsContext);

  const spOrgData = useContext(SPOrgContext);
  const {
    org: { rate_card: rateCard },
  } = spOrgData;

  if (!rateCard) {
    throw new Error('An organisation must have a valid rate card');
  }

  // todo::SP Query Committed Capacity Configs only when the Committed Capacity is true
  const tagsToQuery = [
    'COMMIT_CONFIG',
    `START_DATE=${commitData?.commit_details?.start_date}`,
    `END_DATE=${commitData?.commit_details?.end_date}`,
    `RATE_CARD=${rateCard}`,
    'COMMITTED_CKU_CAPACITY_CONFIGS',
    'COMMITTED_CFU_CAPACITY_CONFIGS',
  ];

  const query = tagsToQuery.join(',');

  const dataFetchingArgs = useMemo(
    () => [{ query, ...params }, { skip: shouldSkipDataFetching(params) }],
    [params, query]
  );
  const dataFetchingFunction = useCallback(useGetStreamingProjectsMetadataQuery, []);

  return (
    <DataFetcherContainer
      dataFetchingArgs={dataFetchingArgs}
      dataFetchingFunction={dataFetchingFunction}
    >
      {(data) => (
        <SPUserCommitMetadataContext.Provider value={data}>
          {children}
        </SPUserCommitMetadataContext.Provider>
      )}
    </DataFetcherContainer>
  );
};
